module.exports = __webpack_public_path__ + "img/apix_logo_white.bf0c432d.png";